<kui-input-group [cleanAddons]="true" class="group">
    <kui-icon kui-input-group-addon name="map-marker-alt"></kui-icon>
    <input
        kui-input
        #input
        type="text"
        [placeholder]="placeholder"
        [ngModel]="value"
        (ngModelChange)="debouncedUpdateSearchTerm($event)"
        (focus)="focus()"
        (blur)="blur(!searching && results?.length)"
    />
</kui-input-group>

@if (showResults) {
    <kui-dropdown-ref [customContent]="resultsDropdown"></kui-dropdown-ref>
}

<ng-template #resultsDropdown>
    @if (searching) {
        <kui-loader size="small"></kui-loader>
    }
    @if (!searching && !results?.length) {
        <div class="px-2">{{ "LEAFLET.NO_RESULTS" | translate }}</div>
    }
    @if (!searching && results?.length) {
        <key-search-results-list [list]="results" [highlightValue]="text?.searchTerm"></key-search-results-list>
    }
</ng-template>
